<div class="min-h-[calc(100vh-64px)] bg-neutral-50 p-4 md:p-6 dark:bg-neutral-900 space-y-6">
  @if (error) {
  <app-alert [type]="'danger'">{{ error }}</app-alert>
  } @if (loading) {
  <div class="my-6"><app-loading size="large" /></div>
  } @if (!loading && product) {
  <app-product-details-section [product]="product" />

  @if (version === 'v1') {
  <app-product-specifications [specifications]="productSpecifications" />
  }
  <app-product-trade-policies [stores]="product.stores" />

  <div class="space-y-4">
    <app-tabs [defaultActiveId]="product.skus[0].id.toString()">
      @for (sku of product.skus || []; track sku.id) {
      <app-tab-pane [id]="sku.id.toString()" [label]="'SKU ' + sku.id">
        <app-sku-details-card
          [sku]="sku"
          [skuSpecifications]="skuSpecifications.get(sku.id)"
        />

        <div class="mt-4 space-y-0">
          @if (version === 'v1') {
          <app-sku-prices [sku]="sku" />
          }
          <app-sku-simulation
            [skuId]="sku.id"
            [franchises]="franchises"
            [tradePolicies]="tradePolicies"
            [loadingAccounts]="loadingAccounts"
          />
          @if (!isMarketplaceProduct()) {
          <app-sku-inventory
            [skuId]="sku.id"
            [franchises]="franchises"
            [loadingAccounts]="loadingAccounts"
          />
          @if (isAdmin) {
          <app-inventory-history-var-l [skuId]="sku.id" [franchises]="franchises" [loadingAccounts]="loadingAccounts" />
          }
          }
        </div>
      </app-tab-pane>
      } @empty {
      <div class="text-sm text-neutral-600">Nenhum SKU encontrado.</div>
      }
    </app-tabs>
  </div>
  }
</div>
